import { render } from "./Desktop.vue?vue&type=template&id=25de5759&scoped=true"
import script from "./Desktop.vue?vue&type=script&lang=js"
export * from "./Desktop.vue?vue&type=script&lang=js"

import "./Desktop.vue?vue&type=style&index=0&id=25de5759&lang=less&scoped=true"

import exportComponent from "E:\\work\\苏州卓盛\\捷博独立发货\\jb-dji-wms-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25de5759"]])

export default __exports__